

























































































import { Prop, Component, Vue } from "vue-property-decorator";
@Component
export default class Caption extends Vue {

  @Prop({ type: Boolean })
  showCaption: boolean = false;

  @Prop({ type: String })
  title!: string;

  @Prop({ type: String })
  description!: string;

  public closeCaption(): void {
    this.$emit("close");
  }
}
